// package.json
var name = "vite-env-only";
var package_default = {
  name,
  version: "3.0.3",
  description: "Vite plugins for isolating server-only and client-only code",
  keywords: [
    "vite-plugin",
    "env",
    "only",
    "client",
    "server",
    "macro",
    "deny",
    "imports"
  ],
  repository: "pcattori/vite-env-only",
  author: "pcattori",
  license: "MIT",
  type: "module",
  exports: {
    ".": {
      import: "./dist/index.js",
      require: "./dist/index.cjs"
    },
    "./macros": {
      import: "./dist/macros.js",
      require: "./dist/macros.cjs"
    },
    "./package.json": "./package.json"
  },
  scripts: {
    typecheck: "tsc",
    build: "tsup",
    test: "vitest",
    changeset: "changeset"
  },
  packageManager: "pnpm@9.1.1",
  peerDependencies: {
    vite: "*"
  },
  devDependencies: {
    "@changesets/cli": "^2.27.2",
    "@types/babel__core": "^7.20.5",
    "@types/babel__generator": "^7.6.8",
    "@types/babel__traverse": "^7.20.5",
    "@types/micromatch": "^4.0.7",
    "@types/node": "^20.10.6",
    dedent: "^1.5.1",
    tsup: "^8.0.1",
    typescript: "^5.4.5",
    vite: "^5.0.11",
    vitest: "^1.1.2"
  },
  dependencies: {
    "@babel/core": "^7.23.7",
    "@babel/generator": "^7.23.6",
    "@babel/parser": "^7.23.6",
    "@babel/traverse": "^7.23.7",
    "@babel/types": "^7.23.6",
    "babel-dead-code-elimination": "^1.0.6",
    micromatch: "^4.0.5"
  },
  prettier: {
    semi: false
  },
  files: [
    "dist"
  ],
  release: {
    branches: [
      "main"
    ]
  }
};

export {
  name,
  package_default
};
